{
  "comment": "M7 spec §12.1 'logging now' (D-340: Career story logs): the Career keeps the last guardianKillsMax guardian kills and the last tetherSalesMax tetherstone sales (the oldest entry drops first). Tetherstone sale days are Career clock days (gameTime ÷ saleDayS, the strategic faction-day length); guardian kill days are the worker's faction day. Starting values, tune freely.",
  "guardianKillsMax": 32,
  "tetherSalesMax": 64,
  "saleDayS": 600
}
